import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const serviceApi = createApi({
  reducerPath: "serviceApi",
  baseQuery,
  tagTypes: ["service"],

  endpoints: (builder) => ({
    getService: builder.query({
      query: ({ id }) =>`customers/services/${id}`,
      transformResponse: (response) => response?.data ?? "",
      providesTags: ["service"],
    }),

    createService: builder.mutation({
      query: ({ id, ...data }) => ({
        url:`customers/services/${id}`, 
        method: "PUT",
        headers: { 
          "X-Request-Id": Math.random().toString(36).substring(2)
        },
        body: { services: data },
      }),
      invalidatesTags: ["service"],
    }),
 
  }),
});

export const {
 useLazyGetServiceQuery,
 useCreateServiceMutation

 
} = serviceApi;
